import { apiClient, getPlatformUrl } from "../../lib/api";

export class GraphGateway {
  async fetchRelevanceDef(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/v2/graph/nodes/relevance?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchStratNodesDef(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/v2/graph/strat/nodes?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchStratBoundsDef(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/graph/strat/bounds/${req}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async setStratBoundsDef(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/graph/strat/bounds`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async deleteStratBoundsDef(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/graph/strat/bounds/${req}`;
    const res = await apiClient.remove({ url: url });
    return res as any;
  }

  async fetchDistributeDef(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/v2/graph/distribution?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchInspectionDef(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/graph/nodes/inspection`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchRobustnessDef(model_id: string, req: any): Promise<any> {
    const url = `${getPlatformUrl()}/api/message-queue/data-robustness/${model_id}/limited-parameter-estimation`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchRobustnessStatus(task_id: string): Promise<any> {
    const url = `${getPlatformUrl()}/api/message-queue/status?task_id=${task_id}`;
    const res = await apiClient.get({ url: url});
    return res as any;
  }

  async fetchRobustnessResult(task_id: string): Promise<any> {
    const url = `${getPlatformUrl()}/api/message-queue/result?task_id=${task_id}`;
    const res = await apiClient.get({ url: url});
    return res as any;
  }

  async fetchExDoDw(model_id: string, req: any): Promise<any> {
    const url = `${getPlatformUrl()}/api/data-robustness/dwmodel/${model_id}/exhaustive-do-dw`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchPublishExDo(report_id: string): Promise<any> {
    const url = `${getPlatformUrl()}/api/data-robustness/dwmodel-report-do/${report_id}/publish-exhaustive-do`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchInterventionDistribution(model_id: string, node_value: string): Promise<any> {
    const url = `${getPlatformUrl()}/causal-inference/bnmodel/${model_id}/node/${node_value}/distribution`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        // result は "data:application/octet-stream;base64,AAAA..." の形式
        const res = reader.result as string;
        resolve(res.split(',')[1]);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async fetchGeneratePDF(req: any): Promise<any> {
    const base = getPlatformUrl();
    //const base = "http://localhost:8081";
    const url1 = `${base}/xcausal/v2/graph/generate-pdf/prepare`;
    const res1 = await apiClient.post({ url: url1, body: {} });
    const url2 = res1.url;
    const data = {} as any;
    data['files'] = {};
    for (const item of req.values()) {
      if (item instanceof File) {
        data['files'][item.name] = await this.blobToBase64(item);
      } else {
        data['data'] = JSON.parse(item);
      }
    }

    await fetch(url2, {
      method: "PUT",
      body: JSON.stringify(data),
      // 署名PUTはクッキー不要。基本 omit 推奨
      credentials: "omit",
      mode: "cors",
    });

    const url3 = `${base}/xcausal/v2/graph/generate-pdf/execute`;
    const data2 = {'path': res1.path} as any;
    const res = await apiClient.post({ url: url3, body: data2, headers: { 'Content-Type': 'application/json' }, responseType: 'blob' });
    const url4 = `${base}/xcausal/v2/graph/generate-pdf/cleanup`;
    await apiClient.upload({ url: url4, body: data2, headers: { 'Content-Type': 'application/json' }, responseType: 'blob' });
    return res as any;
  }

  async fetchBatchEdit(model_id: string, req: any): Promise<any> {
    const url = `${getPlatformUrl()}/causal-inference/bnmodel/${model_id}/batch-edit`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }
}
